import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    addRecord,
    addRecordSuccess,
    addRecordFailure,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    resendInvitation,
    resendInvitationSuccess,
    resendInvitationFailure,
    fetchActivities,
    fetchActivitiesSuccess,
    fetchActivitiesFail
} from './users.action';

import {
    fetchRecordsSuccess as fetchRecordsSuccessRole,
} from '../Roles/roles.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { UsersTableService } from './users-table.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { ActivityTableService } from './activity-table.service';


@Injectable()
export class UsersRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'client-users';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;
                        const roles = data.roles;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        
                        this.moduleTableService.roles = roles;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: listData, total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchActivities$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchActivities),
            exhaustMap((data: any) => {
                const url = 'client-activities/'+data.id;
                return this.crudServerService.fetchTableData(url, this.activityTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;
                        const actions = data.actions;

                        this.activityTableService.page = data.pagination.current_page;
                        this.activityTableService.lastPage = data.pagination.last_page;
                        this.activityTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        
                        this.activityTableService.actions = actions;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchActivitiesSuccess({activities: listData, totalActivity: total});
                    }),
                    
                    catchError((activity_error) =>
                        of(activity_error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(activity_error, "error");
                            }),
                            map(() => fetchActivitiesFail({ activity_error })) // Dispatch 
                        )
                    )
                )
            })

            // exhaustMap((data: any) => {
            //     const url = 'client-activities/'+data.id;
            //     return this.crudServerService.fetchData(url).pipe(
            //         map( (response) => {
            //             const activities = response.data;
            //             this.alertService.triggerAlert(response.message, "success");
            //             return fetchActivitiesSuccess({activities});
            //         }),
                    
            //         catchError((activity_error) =>
            //             of(activity_error).pipe(
            //                 tap(() => {
            //                     this.alertService.triggerAlert(activity_error, "error");
            //                 }),
            //                 map(() => fetchActivitiesFail({ activity_error })) // Dispatch 
            //             )
            //         )
            //     )
            // })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = 'client-users';
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, "/users");
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );
    
    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'client-users/'+data.id+"/edit";
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");

                        this.store.dispatch(fetchRecordsSuccessRole({ listData: response.data.roles }));

                        return fetchSingleRecordSuccess({singleData: response.data.user});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/users");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'client-user-update/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, "/users");
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = 'client-users/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords());
                        this.routeService.triggerRoute(null, "/users");
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
    
    resendInvitation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(resendInvitation),
            exhaustMap((data: any) => {
                const url = 'resend-client-invitation/'+data.id+'/1';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return resendInvitationSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => resendInvitationFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private tableService: DatatableService,
        private moduleTableService: UsersTableService,
        private activityTableService: ActivityTableService,
        public helperService: HelperService
    ) { }

}